export default function Skeleton() {
  return <div className='absolute left-0 top-0 h-22 w-full bg-white lg:h-30' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between lg:px-32'>
                <div className='flex flex-col items-center justify-center'>
                    <div className='mb-1 h-12 w-12 animate-pulse rounded-full bg-gray-100 lg:mb-4 lg:h-16 lg:w-16'></div>
                    <div className='h-5 w-20 animate-pulse rounded bg-gray-100 lg:h-6 lg:w-35'></div>
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <div className='mb-1 h-12 w-12 animate-pulse rounded-full bg-gray-100 lg:mb-4 lg:h-16 lg:w-16'></div>
                    <div className='h-5 w-20 animate-pulse rounded bg-gray-100 lg:h-6 lg:w-35'></div>
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <div className='mb-1 h-12 w-12 animate-pulse rounded-full bg-gray-100 lg:mb-4 lg:h-16 lg:w-16'></div>
                    <div className='h-5 w-20 animate-pulse rounded bg-gray-100 lg:h-6 lg:w-35'></div>
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <div className='mb-1 h-12 w-12 animate-pulse rounded-full bg-gray-100 lg:mb-4 lg:h-16 lg:w-16'></div>
                    <div className='h-5 w-20 animate-pulse rounded bg-gray-100 lg:h-6 lg:w-35'></div>
                </div>
                <div className='hidden flex-col items-center justify-center md:flex'>
                    <div className='mb-1 h-12 w-12 animate-pulse rounded-full bg-gray-100 lg:mb-4 lg:h-16 lg:w-16'></div>
                    <div className='h-5 w-20 animate-pulse rounded bg-gray-100 lg:h-6 lg:w-35'></div>
                </div>
                <div className='hidden flex-col items-center justify-center md:flex'>
                    <div className='mb-1 h-12 w-12 animate-pulse rounded-full bg-gray-100 lg:mb-4 lg:h-16 lg:w-16'></div>
                    <div className='h-5 w-20 animate-pulse rounded bg-gray-100 lg:h-6 lg:w-35'></div>
                </div>
                <div className='flex flex-col justify-center md:hidden'>
                    <div className='mb-1 h-12 w-6 animate-pulse rounded-s-full bg-gray-100 lg:mb-4 lg:h-16 lg:w-16'></div>
                    <div className='h-5 w-6 animate-pulse rounded bg-gray-100 lg:h-6 lg:w-35'></div>
                </div>
            </div>
        </div>;
}